export const Nodejs = [
    {
      question: "What is Node.js?",
      option1: "A web browser",
      option2: "A JavaScript runtime built on Chrome's V8 JavaScript engine",
      option3: "A front-end framework",
      option4: "A relational database",
      ans: 2,
    },
    {
      question: "Which module is commonly used for building web servers in Node.js?",
      option1: "http",
      option2: "fs",
      option3: "path",
      option4: "url",
      ans: 1,
    },
    {
      question: "How do you include additional modules in your Node.js application?",
      option1: "Using import statement",
      option2: "Using require() function",
      option3: "Using include() function",
      option4: "Using load() function",
      ans: 2,
    },
    {
      question: "Which of the following is NOT a core module in Node.js?",
      option1: "http",
      option2: "fs",
      option3: "path",
      option4: "mongo",
      ans: 4,
    },
    {
      question: "What is the purpose of package.json file in a Node.js project?",
      option1: "To store user information",
      option2: "To manage project dependencies and configuration",
      option3: "To define CSS styles",
      option4: "To execute JavaScript code",
      ans: 2,
    },
    {
      question: "Which framework is commonly used with Node.js for building RESTful APIs?",
      option1: "Express.js",
      option2: "Angular.js",
      option3: "React.js",
      option4: "Vue.js",
      ans: 1,
    },
    {
      question: "How do you handle asynchronous operations in Node.js?",
      option1: "Using setTimeout() function",
      option2: "Using setInterval() function",
      option3: "Using callbacks, Promises, or async/await",
      option4: "Using synchronous functions only",
      ans: 3,
    },
    {
      question: "Which database is commonly used with Node.js for NoSQL data storage?",
      option1: "MySQL",
      option2: "PostgreSQL",
      option3: "SQLite",
      option4: "MongoDB",
      ans: 4,
    },
    {
      question: "What is the purpose of middleware in Node.js?",
      option1: "To handle routing",
      option2: "To manage static files",
      option3: "To enhance the functionality of Express.js applications",
      option4: "To handle database operations",
      ans: 3,
    },
    {
      question: "How do you start a Node.js server listening on port 3000?",
      option1: "node server.js",
      option2: "npm start",
      option3: "node start",
      option4: "npm server",
      ans: 1,
    },
  ];
  